import { z } from "zod";
/**
 * Polymorphic parent supported by the MVP. Extending this set requires:
 *   1. adding the value here;
 *   2. mirroring it in the `document.parent_type` MySQL enum (migration);
 *   3. teaching `DocumentService` how to assert tenancy for that parent.
 *
 * Same source-of-truth pattern as `CompanyRoleArray` / `OrderKindArray`: the array is the
 * single canonical list reused by the Zod schema, the TypeORM entity (`@Column({type: "enum",
 * enum: DOCUMENT_PARENT_TYPES})`) and the SQL migration.
 */
export const DOCUMENT_PARENT_TYPES = ["CUSTOMER", "SERVICE_TARGET"];
export const DocumentParentTypeSchema = z.enum(DOCUMENT_PARENT_TYPES);
/**
 * Discriminant. `text` carries `body`; `file` carries the S3 metadata. The applicative XOR
 * invariant on the file vs text columns lives in `DocumentService`.
 */
export const DOCUMENT_KINDS = ["text", "file"];
export const DocumentKindSchema = z.enum(DOCUMENT_KINDS);
export const DocumentMemberSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});
const documentBaseShape = {
    id: z.string(),
    companyId: z.string(),
    memberId: z.string().nullable(),
    member: DocumentMemberSchema.nullable(),
    parentType: DocumentParentTypeSchema,
    parentId: z.string(),
    createdDate: z.coerce.date(),
    lastModifiedDate: z.coerce.date(),
};
export const TextDocumentResponseSchema = z.object({
    ...documentBaseShape,
    kind: z.literal("text"),
    body: z.string(),
});
export const FileDocumentResponseSchema = z.object({
    ...documentBaseShape,
    kind: z.literal("file"),
    originalFilename: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    uploadStatus: z.enum(["pending", "received", "unavailable", "invalid", "legacy"]).optional(),
    uploadChecksumSha256: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .optional(),
});
export const DocumentResponseSchema = z.discriminatedUnion("kind", [
    TextDocumentResponseSchema,
    FileDocumentResponseSchema,
]);
//# sourceMappingURL=document.types.js.map